/**
 * Central registry of route chunk prefetchers.
 *
 * Each entry MUST point at the same dynamic-import path as the matching
 * `React.lazy(() => import(...))` call in `App.tsx`. Vite/Rollup dedupes
 * dynamic imports by request specifier, so calling the registered thunk on
 * hover/focus warms the chunk that `lazy()` will resolve on click.
 *
 * Adding a new lazy route?
 *   1. Add the `lazy(() => import('./pages/Foo'))` to App.tsx.
 *   2. Register the same thunk here under a stable key.
 *   3. Pass `prefetch={routePrefetch.foo}` to any <PrefetchLink to="/foo">.
 */
export const routePrefetch = {
  market: () => import('@/pages/Market'),
  inventory: () => import('@/pages/Inventory'),
  publicProfile: () => import('@/pages/PublicProfile'),
  itemDetail: () => import('@/pages/ItemDetail'),
  profile: () => import('@/pages/Profile'),
  settings: () => import('@/pages/Settings'),
  activity: () => import('@/pages/Activity'),
  

  
  transactions: () => import('@/pages/TransactionHistory'),
  notifications: () => import('@/pages/Notifications'),
  
  admin: () => import('@/pages/Admin'),
  cardShows: () => import('@/pages/CardShowsIndex'),
  cardShowDetail: () => import('@/pages/CardShowDetail'),
} as const;

export type RoutePrefetchKey = keyof typeof routePrefetch;
